<template>
  <div class="gmb-attribute-chip" @click="toggleValue">
    <v-chip
      v-if="value && !deleteMode"
      color="primary"
      outlined
      class="gmb-attribute-chip__checked"
    >
      <v-icon left>
        icon-check
      </v-icon>
      {{ name }}
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-icon
            right
            v-bind="attrs"
            v-on="on"
            size="20px"
            @click.stop="$emit('add-description')"
          >
            mdi-settings
          </v-icon>
        </template>
        <span>{{
          description || $t("message.facilityDetails.services.addDescription")
        }}</span>
      </v-tooltip>
    </v-chip>
    <v-chip outlined v-else-if="value && deleteMode" class="danger">
      <v-icon left>
        icon-trash
      </v-icon>
      {{ name }}
    </v-chip>
    <v-chip v-else-if="value === false">
      <v-icon left>
        mdi-cancel
      </v-icon>
      {{ name }}
    </v-chip>
    <v-chip outlined v-else>
      <v-icon left>
        icon-plus
      </v-icon>
      {{ name }}
    </v-chip>
  </div>
</template>

<script>
export default {
  name: "GmbServiceMassChip",
  props: {
    name: {
      type: String,
      required: true
    },
    value: {
      type: [Boolean]
    },
    description: {
      type: String
    },
    booleanOnly: {
      type: [Boolean],
      default: () => false
    },
    toggleOnly: {
      type: Boolean,
      default: false
    },
    deleteMode: {
      type: Boolean,
      default: () => false
    }
  },
  methods: {
    toggleValue() {
      let newValue = true;
      if (this.deleteMode) {
        if (this.value) {
          newValue = null;
        }
      } else {
        if (this.value === true && this.toggleOnly) {
          newValue = null;
        } else if (this.value === true) {
          newValue = false;
        } else if (this.value === false && this.booleanOnly) {
          newValue = true;
        } else if (this.value === false) {
          newValue = null;
        }
      }

      this.$emit("input", newValue);
    }
  }
};
</script>
<style lang="scss" scoped>
.gmb-attribute-chip {
  display: inline-flex;
  user-select: none;

  .v-chip {
    cursor: pointer;
    user-select: none;
    border: 1px solid rgba(0, 0, 0, 0.05);
    filter: drop-shadow(0px 2px 5px rgba(0, 0, 0, 0.05));
    height: unset;
    min-height: 40px;
    border-radius: 20px;
    @include font-size(14px);
    font-weight: 400;
    margin: $spacing / 2 $spacing $spacing / 2 0;
    padding: 5px $spacing * 2;
    max-width: 100%;
    white-space: normal;

    &.gmb-attribute-chip__checked {
      padding-right: 0 !important;

      .v-icon--right {
        width: 40px;
        border-left: 1px solid #bad9d7 !important;
        height: calc(100% + 10px);
        overflow: hidden;
        margin-right: 0px;

        &:hover {
          background: #cae8e6;
        }
      }
    }

    &.v-chip--outlined.v-chip--no-color {
      background: $light !important;

      &.danger {
        color: $attribute-remove-color !important;
        background: $attribute-remove-bg-color !important;
      }
    }

    &.v-chip--outlined.primary {
      background: $attribute-active-bg-color !important;
    }

    &:not(.v-chip--active) {
      background: $attribute-inactive-bg-color;
    }

    &:hover::before {
      opacity: 0;
    }
  }
}
</style>
